export const CATEGORIES = [
  { key: "crystals", label: "Crystals" },
  { key: "minerals", label: "Rare Minerals" },
  { key: "tarot", label: "Tarot Decks" },
  { key: "sage", label: "Sage & Smoke" },
  { key: "crochet", label: "Crochet" },
  { key: "beauty", label: "Beauty" },
  { key: "jewelry", label: "Jewelry" },
  { key: "scarves", label: "Scarves" },
];

export const STONES = [
  { key: "moonstone", label: "Moonstone" },
  { key: "rose-quartz", label: "Rose Quartz" },
  { key: "obsidian", label: "Obsidian" },
  { key: "clear-quartz", label: "Clear Quartz" },
  { key: "tigers-eye", label: "Tiger's Eye" },
  { key: "pyrite", label: "Pyrite" },
  { key: "amethyst", label: "Amethyst" },
  { key: "black-tourmaline", label: "Black Tourmaline" },
  { key: "labradorite", label: "Labradorite" },
];

export const categoryLabel = (key) =>
  (CATEGORIES.find((c) => c.key === key) || { label: key }).label;

export const stoneLabel = (key) =>
  (STONES.find((s) => s.key === key) || { label: key || "" }).label;

export const formatPrice = (n) =>
  `₹${Number(n).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
